<template>
  <div>
    <b-modal id="modal-reminder" title="Reminder" centered size="sm">
      <b-row>
        <b-col md="12">
          <p>Select the date for selected datesheets.</p>
        </b-col>
        <b-col md="12">
          <b-form-group
            :invalid-feedback="$t('Date is required')"
            ref="reminder_sdate"
          >
            <flat-pickr
              :config="config"
              v-model="selectedReminderDate"
              class="form-control"
              :placeholder="$t('Select Date')"
            />
          </b-form-group>
        </b-col>
      </b-row>

      <template #modal-footer>
        <b-button
          variant="success"
          :disabled="sendingSelected"
          class="btn-icon"
          @click="sendSelectedReminder()"
        >
          <b-spinner v-if="sendingSelected" small type="grow" class="mr-50" />
          <span class="align-middle">{{ $t("Send") }}</span>
        </b-button>
      </template>
    </b-modal>

    <b-sidebar
      id="sidebar-right"
      ref="mySidebar"
      bg-variant="white"
      v-model="visibility"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ $t("Publish Datesheet") }}</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hideSideBar()"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row>
          <b-col md="12">
            <b-form-group
              :label="$t('Publish From')"
              :invalid-feedback="$t('Date is required')"
              ref="pub_from"
            >
              <flat-pickr
                :config="config"
                ref="pub_from"
                v-model="myObj.publishedFrom"
                class="form-control"
                :placeholder="$t('Select Date')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Publish Till')"
              :invalid-feedback="$t('Date is required')"
              ref="pub_till"
            >
              <flat-pickr
                :config="config"
                ref="pub_till"
                v-model="myObj.publishedTo"
                class="form-control"
                :placeholder="$t('Select Date')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12" class="mb-1">
            <b-form-group
              :label="$t('Note')"
              :invalid-feedback="$t('Note is required')"
              ref="note"
            >
              <quill-editor
                v-model="myObj.publishNote"
                :options="{
                  modules: {
                    toolbar: editorOptions,
                  },
                  placeholder: $t('Enter note'),
                }"
              >
              </quill-editor>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              @click="Add()"
              :disabled="publishing"
              block
            >
              <b-spinner v-if="publishing" small type="grow" />
              <span v-else>{{ $t("Publish") }}</span>
            </b-button>
          </b-col>
          <b-col md="12" class="mt-1" v-if="showBtn">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="danger"
              @click="unPub()"
              :disabled="unpublishing"
              block
            >
              <b-spinner v-if="unpublishing" small type="grow" />
              <span v-else>{{ $t("Unpublish") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <!-- Reminder Sidebar -->
    <b-sidebar
      id="reminder-sidebar"
      ref="reminderSidebar"
      bg-variant="white"
      v-model="reminderVisibility"
      sidebar-class="sidebar-lg"
      right
      no-header
      backdrop
      shadow
    >
      <div
        class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
      >
        <h5 class="mb-0">{{ $t("Send Reminder") }}</h5>
        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hideReminderSideBar()"
        />
      </div>
      <b-form class="p-2" @submit.prevent>
        <b-row>
          <b-col md="12">
            <b-form-group
              :label="$t('Classes')"
              :invalid-feedback="$t('Please select at least one class')"
              ref="reminder_classes"
            >
              <v-select
                multiple
                :closeOnSelect="false"
                v-model="reminderObj.clsIDs"
                :options="[{ id: 0, name: $t('All Classes') }, ...classOptions]"
                :reduce="(val) => val.id"
                label="name"
                :clearable="false"
                :placeholder="$t('Select Classes')"
                @input="FillSections()"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Sections')"
              :invalid-feedback="$t('Please select at least one section')"
              ref="reminder_sections"
            >
              <v-select
                multiple
                :closeOnSelect="false"
                v-model="reminderObj.secIDs"
                :options="sectionOptions"
                :reduce="(val) => val.id"
                label="section"
                :clearable="false"
                :placeholder="$t('Select Sections')"
                @input="setSection()"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Exam Type')"
              :invalid-feedback="$t('Exam type is required')"
              ref="reminder_exam"
            >
              <v-select
                v-model="reminderObj.examID"
                :options="examOptions"
                :reduce="(val) => val.id"
                label="examType"
                :clearable="false"
                :placeholder="$t('Select Exam Type')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Session')"
              :invalid-feedback="$t('Session is required')"
              ref="reminder_session"
            >
              <v-select
                v-model="reminderObj.sessionID"
                :options="sessionOptions"
                :reduce="(val) => val.id"
                label="session"
                :clearable="false"
                :placeholder="$t('Select Session')"
              />
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group
              :label="$t('Reminder For')"
              :invalid-feedback="$t('Date is required')"
              ref="reminder_date"
            >
              <flat-pickr
                :config="config"
                v-model="reminderObj.date"
                class="form-control"
                :placeholder="$t('Select Date')"
              />
            </b-form-group>
          </b-col>

          <b-col md="12" class="mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="success"
              @click="sendReminder()"
              :disabled="sending"
              block
            >
              <b-spinner v-if="sending" small type="grow" />
              <span v-else>{{ $t("Send Reminder") }}</span>
            </b-button>
          </b-col>
        </b-row>
      </b-form>
    </b-sidebar>

    <ManageDatesheets
      v-if="showSheets"
      :sessionOptions="sessionOptions"
      @back="showSheets = false"
    />

    <b-card v-else>
      <b-row class="mt-1">
        <b-col xl="2" lg="3" md="4" sm="12" cols="12" v-if="rights.add">
          <b-button
            @click="open(0)"
            block
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
          >
            <feather-icon icon="PlusIcon" class="mr-50" />
            <span class="align-middle">{{ $t("Datesheet") }}</span>
          </b-button>
        </b-col>

        <b-col
          class="mt-lg-0 mt-md-0 mt-sm-1 mt-1 d-flex align-items-center"
          xl="10"
          lg="9"
          md="8"
          sm="12"
          cols="12"
        >
          <b-form-group class="mb-0 w-100">
            <b-input-group>
              <b-input-group-prepend is-text>
                <feather-icon icon="SearchIcon" />
              </b-input-group-prepend>

              <b-form-input
                v-model="searchQuery"
                :placeholder="$t('Search') + '...'"
              >
              </b-form-input>
            </b-input-group>
          </b-form-group>
          <b-button
            variant="outline-primary"
            v-b-tooltip.hover.top
            :title="$t('Export')"
            class="btn-icon ml-50"
            :disabled="exporting"
            @click="exportData()"
          >
            <b-spinner v-if="exporting" small varaint="primary" />
            <feather-icon v-else icon="UploadIcon" class="" />
          </b-button>
          <b-button
            v-if="sheetVisible.includes(reportDomain)"
            variant="info"
            v-b-tooltip.hover.top
            :title="$t('Manage Datesheets')"
            class="btn-icon ml-50"
            :disabled="exporting"
            @click="openManageSheet()"
          >
            <feather-icon icon="FileTextIcon" class="" />
          </b-button>
          <b-button
            variant="success"
            v-b-tooltip.hover.top
            :title="$t('Send Reminder')"
            class="btn-icon ml-50"
            @click="openReminder()"
          >
            <feather-icon
              icon="BellIcon"
              :badge="selectedIDs.length"
              badge-classes="badge-primary adjust-badge-position"
            />
          </b-button>
        </b-col>
      </b-row>

      <b-table
        class="mt-1"
        ref="selectableTable"
        :items="filters"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :busy="dataLoading"
        show-empty
        responsive
        hover
        :selectable="rights.edit"
        select-mode="multi"
        @row-selected="rowSelect($event)"
      >
        <!-- @row-selected="open($event[0].datesheetGrid.id, $event[0])" -->
        <template #empty="scope">
          <h3 class="mt-1 mb-1 text-center">
            {{ $t("No records found") }}
          </h3>
        </template>
        <template #table-busy>
          <div class="d-flex justify-content-center mb-3 mt-3">
            <b-spinner
              style="width: 3rem; height: 3rem"
              type="grow"
              variant="primary"
              :label="$t('Spinning')"
            ></b-spinner>
          </div>
        </template>
        <template #cell(metaGrid.cls)="data">
          <b-badge variant="light-primary">
            {{ data.value }}
          </b-badge>
        </template>
        <template #cell(metaGrid.sec)="data">
          <b-badge variant="light-primary">
            {{ data.value }}
          </b-badge>
        </template>
        <template #cell(metaGrid.exam)="data">
          <b-badge variant="light-primary">
            {{ data.value }}
          </b-badge>
        </template>
        <template #cell(metaGrid.session)="data">
          <b-badge variant="light-primary">
            {{ data.value }}
          </b-badge>
        </template>

        <template #head()="scope">
          <div :class="scope.label == 'actions' && 'ml-2'">
            {{ $t(scope.label) }}
          </div>
        </template>

        <template #cell(actions)="data">
          <div class="">
            <b-button
              v-if="rights.edit"
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              v-b-tooltip.hover.left
              :title="$t('Edit')"
              class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
              @click.stop="open(data.item.datesheetGrid.id, data.item)"
            >
              <feather-icon icon="EditIcon" class="" />
            </b-button>

            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="outline-primary"
              v-b-tooltip.hover.left
              :title="$t('Print')"
              class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
              @click.stop="Print(data.item)"
            >
              <feather-icon icon="PrinterIcon" class="" />
            </b-button>

            <!-- v-if="!data.item.datesheetGrid.isPublished" -->
            <b-button
              v-if="rights.edit"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-primary"
              v-b-tooltip.hover.right
              :title="$t('App Setting')"
              class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
              @click.stop="AddOpen(data.item, true)"
            >
              <feather-icon icon="GlobeIcon" />
            </b-button>

            <b-button
              v-if="rights.delete"
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="outline-danger"
              v-b-tooltip.hover.right
              :title="$t('Delete')"
              class="btn-icon mr-0 mr-sm-1 mb-1 mb-sm-0"
              @click.stop="Delete(data.item.datesheetGrid.id)"
            >
              <feather-icon icon="Trash2Icon" />
            </b-button>
          </div>
        </template>
      </b-table>
      <b-col cols="12" class="d-flex align-items-center justify-content-center">
        <b-pagination
          v-model="currentPage"
          :total-rows="filters.length"
          :per-page="perPage"
          first-number
          last-number
          class="mb-0 mt-1 mt-sm-0"
          prev-class="prev-item"
          next-class="next-item"
        >
          <template #prev-text>
            <feather-icon icon="ChevronLeftIcon" size="18" />
          </template>
          <template #next-text>
            <feather-icon icon="ChevronRightIcon" size="18" />
          </template>
        </b-pagination>
      </b-col>
    </b-card>
  </div>
</template>

<script>
import {
  BCard,
  BRow,
  BCol,
  BFormInput,
  BButton,
  BTable,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  VBTooltip,
  BFormGroup,
  BForm,
  BSpinner,
  BSidebar,
  VBToggle,
  BInputGroupPrepend,
  BFormTextarea,
  BInputGroup,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import ManageDatesheets from "./ManageDatesheets.vue";
import { quillEditor } from "vue-quill-editor";

import { mapActions, mapGetters } from "vuex";

import * as XLSX from "xlsx";

export default {
  components: {
    BFormTextarea,
    BCard,
    BRow,
    BBadge,
    BTable,
    BCol,
    BFormInput,
    BButton,
    BSidebar,
    BFormGroup,
    BInputGroupPrepend,
    BInputGroup,
    BForm,
    BPagination,
    BSpinner,
    BDropdown,
    BDropdownItem,
    flatPickr,
    vSelect,
    quillEditor,
    ManageDatesheets,
  },
  directives: {
    "b-tooltip": VBTooltip,
    "b-toggle": VBToggle,
    Ripple,
  },
  async created() {
    // console.log(this.$store.state.rights);
    let right = {};
    this.$store.state.menu.forEach((el) => {
      el.children.forEach((ch) => {
        right[ch.route] = {
          view: ch.view,
          add: ch.add,
          edit: ch.edit,
          delete: ch.delete,
        };
      });
    });
    this.$store.commit("setRights", right);
    if (!this.$store.state.rights[this.$route.name]) {
      // console.log(this.$store.state.rights[this.$route.name]);
      this.$router.replace({
        name: "misc-not-authorized",
      });
    } else {
      this.rights = this.$store.state.rights[this.$route.name];
      this.LoadData();
      this.LoadOptions(); // Load classes, sections, exam types and
    }
    // this.LoadData();
  },
  computed: {
    filters: function () {
      return this.items.filter((pro) => {
        return (
          (pro.metaGrid.cls &&
            pro.metaGrid.cls
              .toLowerCase()
              .match(this.searchQuery.toLowerCase())) ||
          (pro.metaGrid.sec &&
            pro.metaGrid.sec
              .toLowerCase()
              .match(this.searchQuery.toLowerCase()))
        );
      });
    },
  },
  data() {
    return {
      reportDomain: this.$store.state.report.replace(/_/g, ""),
      editorOptions: [
        ["bold", "italic", "underline"], // toggled buttons
        [{ list: "ordered" }, { list: "bullet" }],
      ],
      rights: {},
      myDepartments: [],
      request: false,
      visibility1: false,
      config: {
        altFormat: "j M, Y",
        altInput: true,
        dateFormat: "Y-m-d",
      },
      sidebarTitle: "Add Subject",
      sidebarButton: "Save",
      buttonIcon: "PlusIcon",
      dataLoading: false,
      visibility: false,
      publishing: false,
      unpublishing: false,
      logoloading: "",
      searchQuery: "",
      currentPage: 1,
      perPage: 30,
      totalRows: 0,
      fields: [
        { label: "Class", key: "metaGrid.cls" },
        { label: "Section", key: "metaGrid.sec" },
        { label: "exam", key: "metaGrid.exam" },
        { label: "session", key: "metaGrid.session" },
        // { label: "syllabus", key: "syllabus" },
        { key: "actions", label: "actions" },
      ],
      items: [],
      selected: null,
      rangeDate: null,
      adding: false,
      showBtn: false,
      myObj: {},
      exporting: false,
      pubObj: {},
      reminderVisibility: false,
      reminderObj: {
        clsIDs: [0],
        secIDs: [0],
        examID: 0,
        sessionID: 0,
        date: null,
      },
      allClasses: [],
      classOptions: [],
      sectionOptions: [{ id: 0, section: "All Sections" }],
      examOptions: [],
      sessionOptions: [],
      sending: false,
      selectedIDs: [],
      sendingSelected: false,
      selectedReminderDate: null,
      showSheets: false,
      sheetVisible: ["myskooliota", "myskooliota2", "myskool"],
    };
  },
  methods: {
    ...mapActions({ get: "get", post: "post", put: "put", delete: "delete" }),

    openManageSheet() {
      this.showSheets = true;
    },

    rowSelect(row) {
      // console.log(row);
      this.selectedIDs = row.reduce((acc, el) => {
        if (el.datesheetGrid) acc.push(el.datesheetGrid.id);
        return acc;
      }, []);
      // console.log(this.selectedIDs);
    },
    async sendSelectedReminder() {
      if (this.selectedReminderDate) {
        this.sendingSelected = true;
        var status = await this.post({
          url:
            this.$store.state.domain +
            "DatesheetGrid/ReminderSelected?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&userID=" +
            this.$store.state.userData.userID,
          body: { gridIDs: this.selectedIDs, date: this.selectedReminderDate },
          message: "Reminder sent successfully!",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.sendingSelected = false;
        if (status) {
          this.$refs.selectableTable.clearSelected();
          this.$bvModal.hide("modal-reminder");
        }
      }
    },

    exportData() {
      this.exporting = true;

      const newData = this.items.map((el) => ({
        class: el.metaGrid.cls,
        section: el.metaGrid.sec,
        exam: el.metaGrid.exam,
        session: el.metaGrid.session,
        publish_from: el.datesheetGrid.publishedFrom,
        publish_till: el.datesheetGrid.publishedTo,
      }));

      const worksheet = XLSX.utils.json_to_sheet(newData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Data");
      XLSX.writeFile(workbook, "datesheet.xlsx");

      this.exporting = false;
    },

    Print(item) {
      // console.log(item);

      var url =
        "https://" +
        this.reportDomain +
        ".myskool.app/Exams/ShowDatesheet?dbb=" +
        this.$store.state.userData.db +
        "&cID=" +
        this.$store.state.userData.cId +
        "&gridID=" +
        item.datesheetGrid.id;

      window.open(url, "_blank");
    },
    open(id, item) {
      this.$router.push({
        name: "datesheet",
        params: {
          id: id,
          obj: item,
        },
      });
    },

    async Edit(id) {
      var obj = {
        url:
          this.$store.state.domain +
          "Subjects/GetSelected?id=" +
          id +
          "&db=" +
          this.$store.state.userData.db,
        token: this.$store.state.userData.token,
      };
      this.myObj = await this.get(obj);
      // console.log("editObj:", this.myObj);
      this.adding = false;
      this.visibility = true;
      this.sidebarTitle = "Edit Subject";
      this.sidebarButton = "Update";
      var elem = this.$refs["subject"];
      elem.state = undefined;
    },

    AddOpen(item, st) {
      this.myObj = { ...item.datesheetGrid };
      this.pubObj = { ...item };
      // console.log(this.myObj, this.pubObj);
      if (this.myObj.isPublished) this.showBtn = true;
      else this.showBtn = false;
      this.adding = st;
      this.visibility = true;

      var elem = this.$refs["pub_from"];
      elem.state = undefined;
      var elem = this.$refs["pub_till"];
      elem.state = undefined;
    },

    checkPubFrom() {
      var elem = this.$refs["pub_from"];
      if (!this.myObj.publishedFrom) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },
    checkPubTill() {
      var elem = this.$refs["pub_till"];
      if (!this.myObj.publishedTo) {
        return (elem.state = false);
      } else {
        return (elem.state = true);
      }
    },

    hideSideBar() {
      this.visibility = false;
    },

    async LoadData() {
      this.dataLoading = true;
      var obj = {
        url:
          this.$store.state.domain +
          "DatesheetGrid/Load?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.items = await this.get(obj);

      this.dataLoading = false;
      // console.log("subject", this.items);
    },

    async Add() {
      this.checkPubFrom();
      this.checkPubTill();
      if (this.checkPubFrom() == true && this.checkPubTill() == true) {
        this.publishing = true;
        this.myObj.isPublished = true;
        // let msg = "Datesheet published successfully!";
        // if (!this.adding) msg = "Publish details updated!";

        var status = await this.post({
          url:
            this.$store.state.domain +
            "DatesheetGrid/Publish?db=" +
            this.$store.state.userData.db +
            "&userID=" +
            this.$store.state.userData.userID,
          body: {
            metaGrid: this.pubObj.metaGrid,
            datesheetGrid: this.myObj,
            datesheetData: this.pubObj.datesheetData,
          },
          message: "Datesheet published successfully!",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.publishing = false;
        if (status) {
          this.LoadData();
          this.visibility = false;
        }
      }
    },

    async Delete(id) {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: this.$t("You won't be able to revert this!"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes, Delete it!"),
      });
      if (result.isConfirmed) {
        var status = await this.delete({
          url:
            this.$store.state.domain +
            "DatesheetGrid/" +
            id +
            "?db=" +
            this.$store.state.userData.db,
          body: null,
          message: "Datesheet removed successfully.",
          context: this,
          token: this.$store.state.userData.token,
        });
        if (status) this.LoadData();
      }
    },
    async unPub() {
      let result = await Swal.fire({
        title: this.$t("Are you sure?"),
        text: "Do you want to unpublish this datesheet?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: this.$t("Yes"),
      });
      if (result.isConfirmed) {
        this.unpublishing = true;
        this.myObj.isPublished = false;
        var status = await this.put({
          url:
            this.$store.state.domain +
            "DatesheetGrid/" +
            this.myObj.id +
            "?db=" +
            this.$store.state.userData.db,
          body: this.myObj,
          message: "Datesheet unpublished!",
          context: this,
          token: this.$store.state.userData.token,
        });
        this.unpublishing = false;
        if (status) {
          this.LoadData();
          this.visibility = false;
        }
      }
    },
    openReminder() {
      if (this.selectedIDs.length > 0) {
        this.selectedReminderDate = null;
        this.$bvModal.show("modal-reminder");
      } else this.reminderVisibility = true;
    },
    hideReminderSideBar() {
      this.reminderVisibility = false;
    },
    async LoadOptions() {
      const obj = {
        url:
          this.$store.state.domain +
          "myclasses/LoadClasses?db=" +
          this.$store.state.userData.db +
          "&cId=" +
          this.$store.state.userData.cId +
          "&dID=0",
        token: this.$store.state.userData.token,
      };
      this.allClasses = await this.get(obj);
      this.classOptions = this.allClasses.map((el) => el.cls);

      const obj2 = {
        url:
          this.$store.state.domain +
          "ExamTypes?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };
      this.examOptions = await this.get(obj2);

      const obj3 = {
        url:
          this.$store.state.domain +
          "Sessions?db=" +
          this.$store.state.userData.db +
          "&cID=" +
          this.$store.state.userData.cId,
        token: this.$store.state.userData.token,
      };

      this.sessionOptions = await this.get(obj3);
    },
    FillSections() {
      // If "All Classes" is selected last, replace all selections with just "All Classes"
      if (this.reminderObj.clsIDs.at(-1) === 0) {
        this.reminderObj.clsIDs = [0];
        this.reminderObj.secIDs = [0]; // Auto-select "All Sections"
        this.sectionOptions = [{ id: 0, section: "All Sections" }];
        return;
      }

      // If "All Classes" is in the selection but not the last selection,
      // remove it to keep only the specifically selected classes
      this.reminderObj.clsIDs = this.reminderObj.clsIDs.filter(
        (id) => id !== 0
      );

      // Reset sections when classes change
      this.reminderObj.secIDs = [];
      this.sectionOptions = [];

      // If more than one class is selected, only show "All Sections" option
      if (this.reminderObj.clsIDs.length > 1) {
        this.sectionOptions = [{ id: 0, section: "All Sections" }];
        this.reminderObj.secIDs = [0]; // Auto-select "All Sections"
        return;
      }

      // If exactly one class is selected, get its sections
      if (this.reminderObj.clsIDs.length === 1) {
        const selectedClassId = this.reminderObj.clsIDs[0];
        const selectedClass = this.allClasses.find(
          (el) => el.cls.id === selectedClassId
        );

        if (
          selectedClass &&
          selectedClass.sections &&
          selectedClass.sections.length > 0
        ) {
          this.sectionOptions = [
            { id: 0, section: "All Sections" },
            ...selectedClass.sections,
          ];
        } else {
          this.sectionOptions = [{ id: 0, section: "All Sections" }];
        }

        this.reminderObj.secIDs = [0]; // Auto-select "All Sections"
      }
    },
    setSection() {
      if (this.reminderObj.secIDs.at(-1) == 0) {
        this.reminderObj.secIDs = [0];
      } else {
        this.reminderObj.secIDs = this.reminderObj.secIDs.filter(
          (el) => el != 0
        );
      }
    },
    validateReminderForm() {
      let isValid = true;

      // Validate classes
      const classesElem = this.$refs.reminder_classes;
      if (!this.reminderObj.clsIDs || this.reminderObj.clsIDs.length === 0) {
        classesElem.state = false;
        isValid = false;
      } else {
        classesElem.state = true;
      }

      // Validate sections
      const sectionsElem = this.$refs.reminder_sections;
      if (!this.reminderObj.secIDs || this.reminderObj.secIDs.length === 0) {
        sectionsElem.state = false;
        isValid = false;
      } else {
        sectionsElem.state = true;
      }

      // Validate exam type
      const examElem = this.$refs.reminder_exam;
      if (!this.reminderObj.examID) {
        examElem.state = false;
        isValid = false;
      } else {
        examElem.state = true;
      }

      // Validate session
      const sessionElem = this.$refs.reminder_session;
      if (!this.reminderObj.sessionID) {
        sessionElem.state = false;
        isValid = false;
      } else {
        sessionElem.state = true;
      }

      // Validate date
      const dateElem = this.$refs.reminder_date;
      if (!this.reminderObj.date) {
        dateElem.state = false;
        isValid = false;
      } else {
        dateElem.state = true;
      }

      return isValid;
    },
    async sendReminder() {
      if (!this.validateReminderForm()) {
        return;
      }

      this.sending = true;

      try {
        let clsIDs = [];
        let secIDs = [];

        if (this.reminderObj.clsIDs.at(-1) === 0) {
          clsIDs = [];
        } else {
          clsIDs = this.reminderObj.clsIDs;
        }
        if (this.reminderObj.secIDs.at(-1) === 0) {
          secIDs = [];
        } else {
          secIDs = this.reminderObj.secIDs;
        }

        const requestBody = {
          clsIDs: clsIDs,
          secIDs: secIDs,
          examID: this.reminderObj.examID,
          sessionID: this.reminderObj.sessionID,
          date: this.reminderObj.date,
        };

        var status = await this.post({
          url:
            this.$store.state.domain +
            "DatesheetGrid/SendReminder?db=" +
            this.$store.state.userData.db +
            "&cID=" +
            this.$store.state.userData.cId +
            "&userID=" +
            this.$store.state.userData.userID,
          body: requestBody,
          message: "Reminder sent successfully!",
          context: this,
          token: this.$store.state.userData.token,
        });

        if (status) {
          this.reminderVisibility = false;
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.sending = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.quill-editor ::v-deep {
  > .ql-container {
    height: 200px;
  }
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
@import "@core/scss/vue/libs/quill.scss";
</style>

<style scoped>
.image {
  float: left;
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  border: 1px solid #ebebeb;
  margin: 5px;
}
.card {
  transition: 0.4s;
}
.card:hover {
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
}

.adjust-badge-position {
  right: -13px;
}
</style>
